// before after ===========

var before_after_sliders = new Swiper(".before_after_slider", {
  slidesPerView: 1,
  spaceBetween: 14,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 1.5,
      spaceBetween: 14,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 14,
    },
    1024: {
      slidesPerView: 2.5,
      spaceBetween: 14,
    },
  },
});

// document.addEventListener("DOMContentLoaded", function () {
//   var videoButtons = document.querySelectorAll(".before_after_video_text"); // Video buttons
//   var modal = document.getElementById("videoModal"); // Modal div
//   var modalVideo = document.getElementById("modalVideo"); // Video iframe inside modal
//   var closeBtn = document.querySelector(".close"); // Close button

//   videoButtons.forEach(function (videoBtn) {
//     videoBtn.addEventListener("click", function (event) {
//       event.preventDefault();

//       var videoUrl = this.getAttribute("href");

//       modalVideo.src = videoUrl;

//       modal.style.display = "flex";

//       document.body.classList.add("video_active");
//     });
//   });

//   closeBtn.addEventListener("click", function () {
//     modal.style.display = "none";
//     modalVideo.src = "";

//     document.body.classList.remove("video_active");
//   });

//   window.addEventListener("click", function (event) {
//     if (event.target == modal) {
//       modal.style.display = "none";
//       modalVideo.src = "";

//       document.body.classList.remove("video_active");
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  var videoButtons = document.querySelectorAll(".before_after_video_text"); // Video buttons
  var modal = document.getElementById("videoModal"); // Modal div
  var modalVideo = document.getElementById("modalVideo"); // Video tag
  var modalSource = document.getElementById("modalSource"); // Source tag inside video
  var closeBtn = document.querySelector(".close"); // Close button

  videoButtons.forEach(function (videoBtn) {
    videoBtn.addEventListener("click", function (event) {
      event.preventDefault();

      var videoUrl = this.getAttribute("href");

      modalSource.src = videoUrl;
      modalVideo.load();
      modal.style.display = "flex";

      document.body.classList.add("video_active");

      // Auto play after load
      modalVideo.play();
    });
  });

  // ====== Close Button Click ======
  closeBtn.addEventListener("click", function (event) {
    event.stopPropagation(); // VERY IMPORTANT: Stop event bubbling
    modal.style.display = "none";

    modalVideo.pause(); // Pause video
    modalSource.src = "";
    modalVideo.load();

    document.body.classList.remove("video_active");
  });

  // ====== Click Outside Modal to Close ======
  window.addEventListener("click", function (event) {
    if (event.target === modal) {
      modal.style.display = "none";

      modalVideo.pause();
      modalSource.src = "";
      modalVideo.load();

      document.body.classList.remove("video_active");
    }
  });
});

// experts slider ==============

var experts_sliders = new Swiper(".experts_slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  breakpoints: {
    426: {
      slidesPerView: 1.5,
      spaceBetween: 20,
    },
    576: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2.5,
      spaceBetween: 40,
    },
    800: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    992: {
      slidesPerView: 3.5,
      spaceBetween: 40,
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 48,
    },
  },
});

// tabify section ================

document.querySelectorAll(".tab_box").forEach((tab) => {
  tab.addEventListener("click", function () {
    // Remove active class from all tabs and content
    document
      .querySelectorAll(".tab_box")
      .forEach((item) => item.classList.remove("active"));
    document
      .querySelectorAll(".tab_content")
      .forEach((item) => item.classList.remove("active"));

    // Add active class to the clicked tab and its content
    tab.classList.add("active");
    const tabIndex = tab.getAttribute("data-tab");
    document.getElementById("tab-content-" + tabIndex).classList.add("active");
  });
});

// review highlights tabify ================

document.querySelectorAll(".review-highlight_tab_box").forEach((tab) => {
  tab.addEventListener("click", function () {
    document
      .querySelectorAll(".review-highlight_tab_box")
      .forEach((item) => item.classList.remove("active"));
    document
      .querySelectorAll(".review-highlight_tab_content")
      .forEach((item) => item.classList.remove("active"));

    // Add active class to the clicked tab and its content
    tab.classList.add("active");
    const tabIndex = tab.getAttribute("data-tab");
    document
      .getElementById("review-highlight_tab-content-" + tabIndex)
      .classList.add("active");
  });
});

// Product Ingredients ========

function openPopup(event, modalId) {
  event.preventDefault();
  document.getElementById(modalId).style.display = "block";
  document.body.classList.add("modal-open");
}

function closePopup(modalId) {
  document.getElementById(modalId).style.display = "none";
  document.body.classList.remove("modal-open");
}

window.onclick = function (event) {
  const modals = document.querySelectorAll(".modal");
  modals.forEach((modal) => {
    if (event.target === modal) {
      closePopup(modal.id);
    }
  });
};

function setupCloseButtons() {
  const closeButtons = document.querySelectorAll(".modal .close-button");
  closeButtons.forEach((button) => {
    button.addEventListener("click", function () {
      closePopup(button.closest(".modal").id);
    });
  });
}

setupCloseButtons();

// faq ==================

document.addEventListener("DOMContentLoaded", function () {
  const questions = document.querySelectorAll(".faq_item h2");

  questions.forEach((question, index) => {
    question.addEventListener("click", function () {
      const nextQuestion = questions[index + 1];
      if (nextQuestion) {
        const nextAnswer = nextQuestion.nextElementSibling;
        if (nextAnswer && nextAnswer.classList.contains("active")) {
          nextAnswer.classList.remove("active");
          nextAnswer.style.display = "none";
          nextQuestion.classList.remove("active");
        }
      }

      const previousQuestion = questions[index - 1];
      if (previousQuestion) {
        const previousAnswer = previousQuestion.nextElementSibling;
        if (previousAnswer && previousAnswer.classList.contains("active")) {
          previousAnswer.classList.remove("active");
          previousAnswer.style.display = "none";
          previousQuestion.classList.remove("active");
        }
      }

      const answer = this.nextElementSibling;
      if (answer.classList.contains("active")) {
        answer.classList.remove("active");
        answer.style.display = "none";
        this.classList.remove("active");
      } else {
        answer.classList.add("active");
        answer.style.display = "block";
        this.classList.add("active");
      }
    });
  });
});

// main product video autoplay =====

$(document).ready(function () {
  var video = $(".main-product__media--grid-item video");

  if (video.length > 0) {
    video.attr("autoplay", true);
    video[0].load();
  }
});

// guarantee faq=================

$(document).ready(function () {
  $(".guarantee_faq_content").on("click", function () {
    const $thisAnswer = $(this).siblings(".guarantee_faq_main_ans");
    const $activeItem = $(".guarantee_faq_content.active");

    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $thisAnswer.slideUp();
    } else {
      $activeItem
        .removeClass("active")
        .siblings(".guarantee_faq_main_ans")
        .slideUp();

      $(this).addClass("active");

      $thisAnswer.slideDown();
    }
  });
});

// reviews video slider =============

var cm_videos_slidersd = new Swiper(".cm_videos_sliders", {
  slidesPerView: 1,
  spaceBetween: 28,
  loop: false,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    576: {
      slidesPerView: 2,
    },
    768: {
      slidesPerView: 3,
    },
    992: {
      slidesPerView: 3,
    },
  },
});

// reviews video play puse btn ========

document.addEventListener("DOMContentLoaded", function () {
  var videoItems = document.querySelectorAll(".video_slider_item");

  videoItems.forEach(function (item, index) {
    var video = item.querySelector("video");
    var playBtn = item.querySelector(".review_play");
    var pauseBtn = item.querySelector(".review_pause");

    function togglePlayPause(video, playBtn, pauseBtn) {
      if (video.paused) {
        video.play();
        playBtn.style.display = "none";
        pauseBtn.style.display = "block";
      } else {
        video.pause();
        playBtn.style.display = "block";
        pauseBtn.style.display = "none";
      }
    }

    if (playBtn && pauseBtn && video) {
      playBtn.addEventListener("click", function () {
        togglePlayPause(video, playBtn, pauseBtn);
      });

      pauseBtn.addEventListener("click", function () {
        togglePlayPause(video, playBtn, pauseBtn);
      });

      video.addEventListener("play", function () {
        playBtn.style.display = "none";
        pauseBtn.style.display = "block";
      });

      video.addEventListener("pause", function () {
        playBtn.style.display = "block";
        pauseBtn.style.display = "none";
      });
    }
  });
});

// review video slider ==============

var swiper = new Swiper(".reviews_video_sliders", {
  slidesPerView: 1,
  spaceBetween: 10,
  loop: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 48,
    },
  },
});

// video autoplay remove on scroll js ============

const videos = document.querySelectorAll("video");
function checkIfInView() {
  videos.forEach((video) => {
    const isHeroBannerVideo = video.closest(".hero-banner");
    if (isHeroBannerVideo) {
      if (!video.hasAttribute("autoplay")) {
        video.setAttribute("autoplay", "true");
      }
      if (!video.hasAttribute("loop")) {
        video.setAttribute("loop", "true");
      }
      if (!video.hasAttribute("muted")) {
        video.setAttribute("muted", "true");
      }
    } else {
      const rect = video.getBoundingClientRect();
      const inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
      if (!inView && !video.paused) {
        video.pause();
      }
    }
  });
}
window.addEventListener("scroll", checkIfInView);
checkIfInView();

// poster img ================

// document.getElementById("playButton").addEventListener("click", function () {
//   var videoElement = document.querySelector("#videoContainer video");
//   var posterImage = document.getElementById("videoPoster");
//   var videoContainer = document.getElementById("videoContainer");
//   posterImage.style.display = "none";
//   videoContainer.classList.add("show-video");
//   if (videoElement) {
//     videoElement.play();
//   }
// });

// cookies popup js  ========

document.addEventListener("DOMContentLoaded", function () {
  var popup = document.getElementById("cookies-popup");
  var cookiesLink = document.querySelector('a[href="#cookies-popup"]');
  var buttons = document.querySelectorAll(".cookies-popup-buttons .btn");
  var closeButton = document.querySelector(".cookies-popup-close");

  if (cookiesLink) {
    cookiesLink.addEventListener("click", function (e) {
      e.preventDefault();
      popup.style.display = "block";
    });
  }

  if (closeButton) {
    closeButton.addEventListener("click", function () {
      popup.style.display = "none";
    });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      popup.style.display = "none";
    });
  });

  window.addEventListener("click", function (e) {
    if (e.target == popup) {
      popup.style.display = "none";
    }
  });
});


// see all ingredients js **************

document.addEventListener("DOMContentLoaded", function() {
  const params = new URLSearchParams(window.location.search);
  const tabParam = params.get('tab');

  if (tabParam) {
    const allTabs = document.querySelectorAll('.tab-link a');

    allTabs.forEach(tab => {
      const tabText = tab.textContent.trim().toLowerCase().replace(/\s+/g, '-');

      if (tabText === tabParam) {
        // Remove 'current' from all
        document.querySelectorAll('.tab-link').forEach(el => el.classList.remove('current'));
        document.querySelectorAll('.tab-content').forEach(el => el.classList.remove('current'));

        // Add 'current' to correct one
        tab.parentElement.classList.add('current');
        const tabId = tab.getAttribute('data-tab');
        document.getElementById(tabId).classList.add('current');

        // 🔥 Scroll to top of tab section smoothly
        const tabSection = document.querySelector('.faq_sec');
        if (tabSection) {
          setTimeout(() => {
            tabSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }, 300);
        }
      }
    });
  }
});


// hedare menu hove js start =================


// // Simple JS for mega menu hover fix
// document.addEventListener('DOMContentLoaded', function() {
//     const megaMenuItems = document.querySelectorAll('li.header__nav-item.has-dropdown.megamenu');
    
//     megaMenuItems.forEach(function(menuItem) {
//         const dropdown = menuItem.querySelector('.header__nav-dropdown.js-dropdown');
        
//         // Mouse menu item ma aave tyare
//         menuItem.addEventListener('mouseenter', function() {
//             // Class add karo
//             dropdown.classList.add('mega-menu-open');
//         });
        
//         // Mouse menu item ma thi jay tyare
//         menuItem.addEventListener('mouseleave', function(event) {
//             // Check karo ke mouse dropdown ma move thayu chhe ke nahi
//             const relatedTarget = event.relatedTarget;
            
//             // Agar mouse dropdown ma move thayu hoy to class na hatao
//             if (dropdown.contains(relatedTarget)) {
//                 return; // Class remove na karo
//             }
            
//             // Agar mouse bija menu ma move thayu hoy
//             const isGoingToOtherMenu = relatedTarget && 
//                 (relatedTarget.classList.contains('header__nav-item') || 
//                  relatedTarget.closest('.header__nav-item'));
            
//             if (isGoingToOtherMenu) {
//                 // Biju menu ma jay chhe to class hatao
//                 dropdown.classList.remove('mega-menu-open');
//             }
//             // Baki cases ma (like body ma jay) pachi check karo
//         });
        
//         // Mouse dropdown ma aave tyare
//         dropdown.addEventListener('mouseenter', function() {
//             // Class add/re-add karo
//             dropdown.classList.add('mega-menu-open');
//         });
        
//         // Mouse dropdown ma thi jay tyare
//         dropdown.addEventListener('mouseleave', function(event) {
//             // Check karo ke mouse parent menu ma jay chhe ke nahi
//             const relatedTarget = event.relatedTarget;
            
//             // Agar mouse parent menu ma move thayu hoy to class na hatao
//             if (menuItem.contains(relatedTarget)) {
//                 return; // Class remove na karo
//             }
            
//             // Baki cases ma class hatao
//             dropdown.classList.remove('mega-menu-open');
//         });
//     });
    
//     // Global: Koi pan bija element upr click kare to sab class remove karo
//     document.addEventListener('click', function(event) {
//         // Agar click menu area bahar thayu hoy
//         if (!event.target.closest('.header__nav-item.has-dropdown')) {
//             const allOpenMenus = document.querySelectorAll('.mega-menu-open');
//             allOpenMenus.forEach(function(dropdown) {
//                 dropdown.classList.remove('mega-menu-open');
//             });
//         }
//     });
// });
// document.addEventListener('DOMContentLoaded', function () {

//     const nav = document.querySelector('nav.header__nav.small-hide.medium-hide.js-nav');
//     const megaMenuItems = document.querySelectorAll(
//         'li.header__nav-item.has-dropdown.megamenu'
//     );

//     megaMenuItems.forEach(function (menuItem) {
//         const dropdown = menuItem.querySelector('.header__nav-dropdown.js-dropdown');

//         // Menu item hover
//         menuItem.addEventListener('mouseenter', function () {
//             dropdown.classList.add('mega-menu-open');
//         });

//         // Dropdown hover
//         dropdown.addEventListener('mouseenter', function () {
//             dropdown.classList.add('mega-menu-open');
//         });
//     });

//     // ⭐ MAIN FIX: nav ni bar mouse jay to badha mega menu close
//     nav.addEventListener('mouseleave', function () {
//         const allOpenMenus = document.querySelectorAll('.mega-menu-open');
//         allOpenMenus.forEach(function (menu) {
//             menu.classList.remove('mega-menu-open');
//         });
//     });

// });

document.addEventListener('DOMContentLoaded', function () {

    const nav = document.querySelector('nav.header__nav.small-hide.medium-hide.js-nav');
    const allMenuItems = document.querySelectorAll('li.header__nav-item');

    function closeAllMegaMenus() {
        document.querySelectorAll('.mega-menu-open').forEach(function (menu) {
            menu.classList.remove('mega-menu-open');
        });
    }

    allMenuItems.forEach(function (menuItem) {
        const dropdown = menuItem.querySelector('.header__nav-dropdown.js-dropdown');

        menuItem.addEventListener('mouseenter', function () {
            // 🔥 Koi pan menu hover thay = pehla badha close
            closeAllMegaMenus();

            // 👉 Jo aa menu ma mega menu hoy to j open
            if (dropdown && menuItem.classList.contains('megamenu')) {
                dropdown.classList.add('mega-menu-open');
            }
        });

        // Dropdown hover (safe check)
        if (dropdown) {
            dropdown.addEventListener('mouseenter', function () {
                dropdown.classList.add('mega-menu-open');
            });
        }
    });

    // Nav ni bar mouse jay = badha close
    nav.addEventListener('mouseleave', function () {
        closeAllMegaMenus();
    });

});


// hedare menu hove js end =================
